import { TargetIcon } from './TargetIcon';

/**
 * author: Doug C. Hardester
 * id 363D29C5-9F0F-43EA-BE7E-D1C2C1418517
 * name target
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/target.svg
 * tags
 */
export const RegistrationMarkIcon = TargetIcon;
export default RegistrationMarkIcon